<!-- Container -->
<div class="container">

  <ul>
    <li class="img-to-text">
      Submit data from the bottom of the "Current Delivery" with the red square & up arrow button.

      <div class="row">
        <!-- submit_log_1.png -->
        <img [src]="getImgs[0]"
          class="help-img"
          (click)="showImage(getImgs[0])" />
      </div>
      

    </li>
    <li>
      If there are errors, you will be directed to these.
      You may not submit until the data is collected.
    </li>
    <li>
      If there are no errors, you will certify and submit
    </li>
    <li class="img-to-text">
      Once submitted, you will get a pop-up confirming your submission.
      You will see the submission under "Completed Deliveries", and you will be emailed a PDF copy of your submitted logbook.

      <div class="row">
        <!-- submit_log_2.png -->
        <img [src]="getImgs[1]"
        class="help-img"
        (click)="showImage(getImgs[1])" />
        

        <!-- submit_log_3.png -->
        <img [src]="getImgs[2]"
          class="help-img"
          (click)="showImage(getImgs[2])" />
      </div>
      

    </li>
  </ul>

</div>
